import React, { useState,useEffect } from "react";
import Sidemenu from "../../layout/sidemenu";
import Header from "../../layout/header";
import { Tooltip } from 'react-tooltip'
import { useNavigate } from "react-router";
import { Formik } from 'formik';
import { ToastContainer, toast } from "react-toastify";
import ErrorMessage from "../../components/ErrorMessage";
import { NoAuthApiRequest,ApiRequest } from "../services/apiservice";
import { ApiEndpoints,ApiEndpointMethod } from "../../utils/endpoints";
import { addProject } from "../../utils/schema";

import  Loader from '../shared/loader'


const Projects = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [loader,setloader]=useState(false);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
                ClientId: '',
                Name: '',
                Id:0,
                UserId:-1,
                Description:'',
                EstimateHours:0,
                StartDate:null,
                EndDate:null,
                StatusId:null,
                TypeId:null,
                Comments:'',
                GitHubLink:'',
            });
    const [search,setsearch]=useState('');
    const [lstClient, setlstClient] =useState([]);
    const [lstTimeZone, setlstTimeZone] =useState([]);
    
      const [currentPage, setCurrentPage] = useState(1);
         const [pageSize, setPageSize] = useState(50); // Default page size
         const [totalPages, setTotalPages] = useState(0);
    
         const [startCount, setstartCount] = useState("");
         const [endCount, setendCount] = useState("");
         const [totalCount, settotalCount] = useState("");
         const [lstProject,setlstProject]=useState([]);

     useEffect(() => {
        
                const fetchData = async () => {
                   await FetchTimeZone();
                   await FetchClient();
                   await fetchProjectList();
                };
                fetchData();
        
            },[]);

    const handleChange = (e) => {
                const { name, value } = e.target;
                if(name == "EstimateHours"){
                    if (value === "" || value.length <= 3){
                   setFormData((prevState) => ({
                           ...prevState,
                       [name]: value
                    }));
                }
            }
            else{
                setFormData((prevState) => ({
                    ...prevState,
                    [name]: value
                }));
            }
            if(name=="StartDate"){
               
                if(value>formData.EndDate)
                {
                setFormData((prevState) => ({
                    ...prevState,
                ["EndDate"]: ""
                }));
            }
        }
    };

    const FetchTimeZone = async() => {
        const data = await ApiRequest(
            ApiEndpoints.Entity.FetchTimeZone,
            ApiEndpointMethod.Get,
            null,
            navigate
          );
          setlstTimeZone(data);
    };

    const FetchClient = async () => {
        const data = await ApiRequest(
            ApiEndpoints.Entity.FetchClient,
            ApiEndpointMethod.Get,
            null,
            navigate
          );
          setlstClient(data);
    };

    const formatDate = (date) => {

        if (date != null) {
            const utcDateString = date.endsWith('Z') ? date : `${date}Z`;
            const localDate = new Date(utcDateString);  // Convert ISO string to Date object
            return localDate.toLocaleDateString(); // Or customize further as needed
        }
        else {
            return "";
        }
    };

    const formatDateUTC = (date) => {

        if (date != null) {
            const utcDateString = date.indexOf('T')>-1 ? date.split('T')[0] : `${date}Z`;
            const localDate = new Date(utcDateString);  // Convert ISO string to Date object
            return localDate.toLocaleDateString(); // Or customize further as needed
        }
        else {
            return "";
        }
    };

    const formatDateUTCDate = (dateString) => {
        if(dateString != "" && dateString != undefined && dateString != null)
        {
        const date = new Date(dateString);
    
        // Adjust to local time
        const month = date.getMonth() + 1; // Months are zero-indexed
        const day = date.getDate();
        const year = date.getFullYear();
    
        return `${month}/${day}/${year}`;
        }
        else{
            return '';
        }
    }

    const formatDateUTCDateTime = (dateString) => {

        if(dateString != "" && dateString != undefined && dateString != null)
        {
        const date = new Date(dateString);
    
        // Adjust to local time
        const month = date.getMonth() + 1; // Months are zero-indexed
        const day = date.getDate();
        const year = date.getFullYear();
                return `${year}-${n(month)}-${n(day)}`;  
        }
        else{
            return null;
        }
    }

    const n=(n)=>{
        return n > 9 ? "" + n: "0" + n;
    }


    const fetchProjectList = async()=>{
        
        await fetchProjects(1,pageSize);
    }

    const handlePageChange = (page) => {
            setCurrentPage(page);
            fetchProjects(page, pageSize);
        };

        
  const handleKeyPress = async (event) => {
    // Check if the pressed key is Enter (keyCode 13)
    if (event.key === 'Enter') {
        await fetchProjects(1,pageSize);
      // You can trigger any logic here when Enter is pressed
    }
  };

  const handleChanges = (event) => {
    setsearch(event.target.value);
  };
    
        const fetchProjects = async (page, limit) => {
             
            try {
               // setLoader(true);
               
               setloader(true);
                const data = await ApiRequest(ApiEndpoints.Entity.FetchProjectList(page, limit,search), ApiEndpointMethod.Get, null, navigate);
               
                
                await setlstProject(data.Item1);
                const totalPages = Math.ceil(data.Item2 / limit);
                setTotalPages(totalPages);
    
                const startcount = Math.ceil(
                    Math.ceil(Math.ceil(page * limit) - limit) + 1
                );
                let endcount = Math.ceil(page * limit);
                if (endcount > data.Item2) {
                    endcount = Math.ceil(endcount - Math.ceil(endcount - data.Item2));
                }
                setstartCount(startcount);
                setendCount(endcount);
                settotalCount(data.Item2);
    
                return { data };
                // Handle the response data here (e.g., show success message or update UI)
            } catch (error) {
                console.error("Error during API call:", error);
                // await setfileList([]);
                // Handle errors (e.g., show an error message to the user)
            }
            finally {
                setloader(false);
             ///   setLoader(false);
            }
        };
    
        const getPageNumbers = () => {
            // Dynamically generate page numbers
            const pageNumbers = [];
            let startPage = Math.max(1, currentPage - 1);  // Prevent going below 1
            let endPage = Math.min(totalPages, currentPage + 1);  // Prevent going above totalPages
          
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers;
          };

          const handleChangeTigger = (name, value) => {
  
            setFormData((prevState) => ({
             ...prevState,
             [name]: value,
           }));
     };

     const ClearField= async()=>{
                                await handleChangeTigger("ClientId", '');
                                await handleChangeTigger("Name",'');
                                await handleChangeTigger("Id", 0);
                                await handleChangeTigger("Description", '');
                                await handleChangeTigger("EstimateHours", 0);
                                await handleChangeTigger("StartDate",'');
                                await handleChangeTigger("EndDate", '');
                                await handleChangeTigger("StartDate",null);
                                await handleChangeTigger("EndDate", null);
                                await handleChangeTigger("UserId", -1);
                                await handleChangeTigger("StatusId", '');
                                await handleChangeTigger("TypeId", '');
                                await handleChangeTigger("Comments", '');

                           
     }

          const EditProject = async(projectId)=>{
            setloader(true);
                document.getElementById('mdlAddProject').click();
            
                        const data = await ApiRequest(ApiEndpoints.Entity.GetProjectDetails(projectId), ApiEndpointMethod.Get, navigate);
                              if(data != null){
                                
                                
                                await handleChangeTigger("ClientId", data.ClientId);
                                await handleChangeTigger("Name", data.Name);
                                await handleChangeTigger("Id", data.Id);
                                await handleChangeTigger("Description", data.Description);
                                await handleChangeTigger("EstimateHours", data.EstimateHours);
                                // await handleChangeTigger("StartDate", formatDateUTCDateTime(data.StartDate));
                                // await handleChangeTigger("EndDate", formatDateUTCDateTime(data.EndDate));
                                await handleChangeTigger("StatusId", data.StatusId);
                                await handleChangeTigger("TypeId", data.TypeId);
                                await handleChangeTigger("Comments", data.Comments);

                           
                                //alert(data);
                              }
                              setloader(false);
          }

    const CreateProject = async (validateForm, setTouched, values) => {
        try{
         
            const errors = await validateForm();
          
            // if (Object.keys(errors).length === 0) {
            if(formData.ClientId<=0){
                toast.error("Please select the client", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if(formData.Name == "" || formData.Name == undefined || formData.Name == null){
                toast.error("Please enter the project name", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if(formData.TypeId == "" || formData.TypeId == undefined || formData.TypeId == null){
                toast.error("Please select the project type", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
            if(formData.StatusId == "" || formData.StatusId == undefined || formData.StatusId == null){
                toast.error("Please select the Status type", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                return true;
            }
                setloader(true);
                const usrDetails = JSON.parse(localStorage.getItem("user"));
                formData.UserId=usrDetails.Id;
                 const data = await ApiRequest(ApiEndpoints.Entity.CreateProject, ApiEndpointMethod.Post, formData, navigate);
                 if(data.success==true){

                    fetchProjects(currentPage,pageSize);
                        document.getElementById('btnc').click();
                            toast.success(data.message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                            await ClearField();
                 }
                 else{
                            toast.error(data.message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                 }              
            
         } catch (error) {
                            // Handle network errors or any other errors
                            console.error("There was an error sending the form data", error);
                            toast.success(error, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
            }
                        finally {
                            setloader(false);
        }

    };

    const typeLabels = {
        1: 'Fixed',
        2: 'Billable',
        3: 'Support'
      };

      const statusLabels = {
        1: 'Active',
        2: 'InActive',
        3: 'Completed',
        4: 'Hold'
      };

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="mb-0">Projects</h5>
                            <div className="d-flex align-items-center">
                                <input className="form-control me-2" placeholder="search..."  onChange={handleChanges}  onKeyDown={handleKeyPress} value={search} type="search" style={{ width: '220px' }} />
                                <button className="btn btn-sm btn-info" id="mdlAddProject" data-bs-toggle="modal"
                                    data-bs-target="#addProject">
                                    <i className="fas fa-plus me-1"></i>Add Project
                                </button>
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table className="table table-bordered bg-white mb-0">
                                <thead>
                                    <tr>
                                        <th width="20%">Name</th>
                                        <th width="20%">Company Name</th>
                                        <th width="10%">Start Date</th>
                                        <th width="10%">End Date</th>
                                        <th width="10%">Estimated Hours</th>
                                        <th width="10%">Type</th>
                                        <th width="10%">Status</th>
                                        <th width="10%">Created Date</th>
                                        <th width="10%">Updated Date</th>
                                        {/* <th width="30%">Description</th> */}
                                        <th width="10%" className="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* <tr>
                                        <td colSpan={4} className="bg-lite">Joe West</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Jonas FinTech</td>
                                        <td>GMT-5</td>
                                        <td></td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ps-4">Jonas Webform</td>
                                        <td>GMT-7</td>
                                        <td></td>
                                        <td className="text-center">
                                            <a className="text-primary me-2" data-tooltip-id="editTooltip" data-tooltip-content="Edit">
                                                <i className="fas fa-edit"></i></a>
                                            <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={4} className="bg-lite">Kevin M.Dorey</td>
                                    </tr> */}
                                    {lstProject?.map((project) => (
                                    <tr>
                                        <td>{project.Name}</td>
                                        <td>{project.CompanyName}</td>
                                        <td>{formatDateUTCDate(project.StartDate)}</td>
                                        <td>{formatDateUTCDate(project.EndDate)}</td>
                                        <td>{project.EstimateHours}</td>
                                        <td>{typeLabels[project.TypeId] || 'Unknown Type'}</td>
                                        <td>{statusLabels[project.StatusId] || 'Unknown Status'}</td>
                                        <td>{formatDateUTCDate(project.CreatedDate)}</td>
                                        <td>{formatDateUTCDate(project.UpdatedDate)}</td>
                                        <td className="text-center">
                                            <a className="text-primary me-2"
                                             data-tooltip-id="editTooltip" data-tooltip-content="Edit"  onClick={()=>{EditProject(project.Id)}}>
                                                <i className="fas fa-edit"></i></a>
                                            {/* <a className="text-danger" data-tooltip-id="deleteTooltip" data-tooltip-content="Delete">
                                                <i className="fas fa-trash-alt"></i></a> */}
                                        </td>
                                    </tr>
                                     ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="pagination-wrapper shadow-sm">
                               <p className="mb-0 me-2">{startCount} - {endCount} of {totalCount}</p>
                               <ul className="pagination">
                                   <li className={`pagination-previous ${currentPage === 1 ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage > 1) handlePageChange(currentPage - 1); }}>
                                           <i className="fa-solid fa-chevron-left"></i>
                                       </a>
                                   </li>

                                   {getPageNumbers().map((page) => (
                                       <li key={page} >
                                           <a className={page === currentPage ? 'active' : ''} onClick={(e) => { e.preventDefault(); handlePageChange(page); }}>
                                               {page}
                                           </a>
                                       </li>
                                   ))}

                                   <li className={`pagination-next ${currentPage === totalPages ? 'disabled' : ''}`}>
                                       <a onClick={(e) => { e.preventDefault(); if (currentPage < totalPages) handlePageChange(currentPage + 1); }}>
                                           <i className="fa-solid fa-chevron-right"></i>
                                       </a>
                                   </li>
                               </ul>
                        </div>

                    </div>
                </div>
            </div>

            <div className="modal fade" id="addProject" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Project</h5>
                            <button type="button" className="btn-close" id="btnc" onClick={()=>{ClearField();}} data-bs-dismiss="modal"></button>
                        </div>
                         <Formik
                                                            enableReinitialize={true}
                                                            initialValues={formData}
                                                            validationSchema={addProject()}
                                                            onSubmit={(values, actions) => {
                                                                CreateProject(values);
                                                            }}
                                                        >
                                                            {({
                                                                values,
                                                                errors,
                                                                touched,
                                                                handleChange1,
                                                                handleBlur,
                                                                handleSubmit,
                                                                setFieldValue,
                                                                setTouched,
                                                                validateForm,
                                                            }) => (
                                                                <form>
                        <div className="modal-body">
                           <div className="row">
                           <div className="col-lg-6">
                            <div className="form-group">
                                <label>Company Name<span className="text-danger">*</span></label>
                                {/* <input className="form-control" type="text" /> */}
                                <select className="form-control"
                                value={formData?.ClientId}
                                name="ClientId"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                >
                                        <option value="0">--select--</option>
                                        {lstClient?.map((client) => (
                                              <option value={client.Id}>
                                        {client.CompanyName}
                                  </option>
                                ))}
                                </select>
                            </div>
                            </div>
                            <div className="col-lg-6">
                                 <div className="form-group">
                                    <label>Project Name<span className="text-danger">*</span></label>
                                    <input className="form-control" type="text" 
                                     value={formData?.Name}
                                     name="Name"
                                     onChange={handleChange}
                                     onBlur={handleBlur}
                                     onInput = {(e) =>{
                                        e.target.value = e.target.value.toString().slice(0,50)
                                    }}
                                     />
                                </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 d-flex justify-content-between">
                                    <div className="form-group w-50 me-2">
                                        <label>Type</label>
                                        <select className="form-control"  value={formData?.TypeId}
                                     name="TypeId"
                                     onChange={handleChange}
                                     onBlur={handleBlur}>
                                            <option value={null}>--select--</option>
                                            <option value="1">Fixed</option>
                                            <option value="2">Billable</option>
                                            <option value="3">Support</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Hours</label>
                                        <input className="form-control"  type="number" 
                                     value={formData?.EstimateHours}
                                     name="EstimateHours"
                                     onChange={handleChange}
                                     onBlur={handleBlur}
                                     max={500}/>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label>Status</label>
                                        <select className="form-control"  value={formData?.StatusId}
                                     name="StatusId"
                                     onChange={handleChange}
                                     onBlur={handleBlur}>
                                            <option value={null}>--select--</option>
                                            <option value="1">Active</option>
                                            <option value="2">InActive</option>
                                            <option value="3">Completed</option>
                                            <option value="4">Hold</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                              <div className="col-lg-12">
                                 <div className="form-group">
                                    <label>Github Link</label>
                                    <input className="form-control" type="text" 
                                     value={formData?.GitHubLink}
                                     name="GitHubLink"
                                     onChange={handleChange}
                                     onBlur={handleBlur}
                                     onInput = {(e) =>{
                                        e.target.value = e.target.value.toString().slice(0,4000)
                                    }}
                                     />
                                </div>
                              </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group mb-0">
                                        <label>Description</label>
                                        <textarea className="form-control"
                                        value={formData?.Description}
                                        name="Description"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onInput = {(e) =>{
                                           e.target.value = e.target.value.toString().slice(0,200)
                                       }}></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="form-group mb-0">
                                        <label>Comments</label>
                                        <textarea className="form-control"
                                        value={formData?.Comments}
                                        name="Comments"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        onInput = {(e) =>{
                                           e.target.value = e.target.value.toString().slice(0,200)
                                       }}
                                       ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="btnClose" className="btn btn-sm btn-outline-info me-2"
                             data-bs-dismiss="modal" onClick={()=>{ClearField();}}>
                                <i className="fas fa-times me-2"></i>Cancel
                            </button>
                            <button type="button" className="btn btn-sm btn-info"
                             onClick={() => CreateProject(validateForm, setTouched, values)}>
                                <i className="fas fa-check me-2"></i>Save
                            </button>
                        </div>
                        </form>
                             )}
                             </Formik>

                    </div>
                </div>
            </div>

            <Tooltip id="editTooltip" />
            <Tooltip id="deleteTooltip" />
            
 {loader && (
                <Loader/>
            )}
        </>
    )
}

export default Projects;